import axios from 'axios';
const base = 'plantilla/emails';
function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}

function getById(id) {
    return axios.get([base, id].join('/'));
}

function update(data) {
    return axios.put([base, data.id_pmail].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const PlantillaEmailService = {
    getAll: getAll,
    register: register,
    getById: getById,
    update: update,
    destroy: destroy
};
export default PlantillaEmailService;
